import { PayloadAction } from '@reduxjs/toolkit'

import {
  TikTokFollowWelcomeSetupModalState,
  TikTokFollowWelcomeSetupStep,
} from 'apps/tiktokFollowWelcome/interfaces'
import { createModalSlice } from 'shared/lib/factory/redux/createModalSlice'

const initialState: TikTokFollowWelcomeSetupModalState = {
  isOpen: false,
  step: TikTokFollowWelcomeSetupStep.INTRO,
}

export const tiktokFollowWelcomeSetupModalSlice = createModalSlice({
  name: 'tiktokFollowWelcomeSetupModal',
  initialState,
  reducers: {
    open: (state) => {
      state.isOpen = true
      state.step = TikTokFollowWelcomeSetupStep.INTRO
    },
    setStep: (state, action: PayloadAction<TikTokFollowWelcomeSetupStep>) => {
      state.step = action.payload
    },
  },
})

export const tiktokFollowWelcomeSetupModalActions = tiktokFollowWelcomeSetupModalSlice.actions
